import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';
import { getConsignmentRuleApiErrorMessage } from '../../utils/consignment-rule.util';

export default function useCreateConsignmentRule() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const createConsignmentRule = async (payload) => {
    setIsSuccess(null);
    try {
      setIsLoading(true);
      const response = await fleetApi.post('/consignment-rule', payload);
      setIsSuccess(true);
      toast.success(
        response.data?.message || 'Règle de consigne créée avec succès.'
      );
    } catch (error) {
      setIsSuccess(false);
      toast.error(getConsignmentRuleApiErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, isSuccess, createConsignmentRule };
}
